export enum SettingsCategory {
  // string enum for clarity
  PREFERENCES = 'PREFERENCES',
  NOTIFICATIONS = 'NOTIFICATIONS',
  // OVERHEARING = 'OVERHEARING',
  ADVANCED = 'ADVANCED',
  INTEGRATIONS = 'INTEGRATIONS',
}
